import React from 'react';
import { Carousel, Image } from '../components';
import plate from '../images/logo-icon.png';
import './Quote.scss';

export const Quote = props => {
  const { data } = props;
  const { items } = data;

  return (
    <Carousel
      containerClassName="wrapper quote-wrapper"
      disableSlider={items.length < 2}
      duration={null}
      buttonsDisabled
      dotsDisabled
      autoPlay
      infinite
    >
      {items.map(item => {
        const { image, quote, name, title } = item;
        return (
          <section className="quote">
            <Image image={image} />
            <div className="quote-body">
              {quote && quote.html && (
                <div className="quote-body-content" dangerouslySetInnerHTML={{ __html: quote.html }} />
              )}
              <div className="quote-body-author">
                <img src={plate} className="logo-icon" alt="EatClub - Save up to 50%" />
                <div>
                  {name && name.text && <h4 className="quote-author-name">{name.text}</h4>}
                  {title && title.text && <span className="quote-author-title">{title.text}</span>}
                </div>
              </div>
            </div>
          </section>
        );
      })}
    </Carousel>
  );
};
